import { PORTAL_TYPES } from '@qler-view/shared_lib/src';
import { httpRequest } from '../../shared/lib/utils/httpClient';

export interface SessionFields {
  fieldLabel: string;
  fieldValue: string;
}

export interface SessionDetails {
  id: number;
  patientName: string;
  sessionFields: SessionFields[];
  additionalSessionFields: SessionFields[];
  facilityDetails: SessionFields[];
  sessionStatus: string;
  waitEndTime: string;
  pastSessionCount: number;
  sessionDocumentCount: number;
  createdOn: string;
  unreadMessageCount: number;
  isExternalConsult: boolean;
  isCustomUrl: boolean;
  isFacilityChanged: boolean;
}

export interface PastSessionDetails {
  consultId: number;
  createdOn: string;
  providerName: string;
  diagnosis: string;
  recommendation: string;
  sessionStatus: string;
}

export interface PastSession {
  totalCount: number;
  pastSessionRecords: PastSessionDetails[];
}

export interface SuccessResponse {
  code: number;
  message: string;
  status: string;
}
export interface DocType {
  files: File[] | null;
  consultId: number;
  providerId: number;
}

export interface DocumentId {
  documentId: number;
}

export interface SessionDoc {
  fileName: string;
  fileSize: number;
  documentId: number;
  documentUrl: string;
  providerId: number;
  consultId: number;
  facilityId: number;
  patientMrn: number;
  uploadedBy: string;
  uploadedOn: string;
}

export const getConsultMoreDetails = async (
  consultId: number,
  userId: number
): Promise<SessionDetails> => {
  const response = await httpRequest<SessionDetails>({
    method: 'GET',
    url: `/facility/case-manager/${consultId}/more-details`,
    headers: {
      userId: userId.toString(),
    },
  });
  return response;
};

export const pastSession = async (consultId: number): Promise<PastSession> => {
  const response = await httpRequest<PastSession>({
    url: `/integration/consult/${consultId}/past-session`,
    method: 'GET',
    headers: {
      portalType: PORTAL_TYPES.FACILITY,
    },
    apiBaseType: 'INTEGRATION',
  });
  return response;
};

export const getSessionDocument = async (
  consultId: number
): Promise<SessionDoc[]> => {
  const response = await httpRequest<SessionDoc[]>({
    url: `/integration/documents/consult/${consultId}`,
    method: 'GET',
    headers: {
      portalType: 'Facility',
    },
    apiBaseType: 'INTEGRATION',
  });
  return response;
};

export const sessionDownloadDocument = async (
  docId: number
): Promise<string> => {
  const response = await httpRequest<string>({
    url: `/integration/documents/${docId}/download`,
    method: 'GET',
    headers: {
      portalType: 'Facility',
    },
    apiBaseType: 'INTEGRATION',
  });
  return response;
};
